export const camelCaseToNormalString = (camelCase: string) => {
  return camelCase && camelCase.length > 3 ? camelCase.replace(/([A-Z])/g, ' $1').trim() : camelCase;
};

export const toTitleCase = (str: string) => {
  return str.replace(/\w\S*/g, (txt: string) => {
    return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
  });
};
